export default __webpack_public_path__ + "static/media/ali-maah-zyOeEm4NsPM-unsplash.d78b7204.jpg";